import {
  Component,
  forwardRef,
  Input
} from '@angular/core';

import {
  NG_VALUE_ACCESSOR,
  NG_VALIDATORS
} from '@angular/forms';
import { InputBaseComponent } from '../base/base.component';

@Component({
  selector: 'jb-input-text',
  templateUrl: './text.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      // tslint:disable-next-line:no-forward-ref
      useExisting: forwardRef(() => InputTextComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      // tslint:disable-next-line:no-forward-ref
      useExisting: forwardRef(() => InputTextComponent),
      multi: true
    }
  ]
})
export class InputTextComponent extends InputBaseComponent {
  protected type: string = 'text';

  @Input()
  public min: number;

  @Input()
  public max: number;

  @Input()
  public step: number;

  @Input('type')
  public inputType: string = 'text';
}



// WEBPACK FOOTER //
// ./src/app/form/input/text/text.component.ts